export function onDeviceReady() {
    document.addEventListener("pause", onPause, false);
    document.addEventListener("resume", onResume, false);
}

function onPause() {
    console.log("Aplicativo Parado.")
}

function onResume() {
    console.log("Continuando a execução do aplicativo.")
}

export function addPauseEventListener(callback) {
    document.addEventListener("pause", callback, false);
}

export function addResumeEventListener(callback) {
    document.addEventListener("resume", callback, false);
}

export function removePauseEventListener(callback) {
    document.removeEventListener("pause", callback, false);
}

export function removeResumeEventListener(callback) {
    document.removeEventListener("resume", callback, false);
}
